import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import getNumberCountPrefix from 'client/helpers/getNumberCountPrefix';
import {
  APARTMENT_LOCATOR_LEASE_SIGN_VOLUME_THRESHOLD_GREEN,
  APARTMENT_LOCATOR_LEASE_SIGN_VOLUME_THRESHOLD_YELLOW,
} from 'common/apartmentLocatorHelpers';

const SrAgentLeaderboardCell = ({
  rank,
  profilePictureUrl,
  agentName,
  leaseVolume,
}) => {
  return (
    <div className='SrAgentLeaderboardCell'>
      <div className='rank'>
        <span className='agentRank'>{rank}
          <span className='signature'>{getNumberCountPrefix(rank)}</span>
        </span>
      </div>
      <div className='thumbnail'>
        <img alt='Locator Profile' src={profilePictureUrl} />
      </div>
      <div className='info'>
        <span className='name'>{agentName}</span>
      </div>
      <div className='leaseVolume'>
        <span
          className={classNames('volume', {
            red: leaseVolume < APARTMENT_LOCATOR_LEASE_SIGN_VOLUME_THRESHOLD_YELLOW,
            yellow: (leaseVolume >= APARTMENT_LOCATOR_LEASE_SIGN_VOLUME_THRESHOLD_YELLOW
                  && leaseVolume < APARTMENT_LOCATOR_LEASE_SIGN_VOLUME_THRESHOLD_GREEN),
            green: leaseVolume >= APARTMENT_LOCATOR_LEASE_SIGN_VOLUME_THRESHOLD_GREEN,
          })}
        >
          {leaseVolume}
        </span>
      </div>
    </div>
  );
};

SrAgentLeaderboardCell.propTypes = {
  rank: PropTypes.number.isRequired,
  profilePictureUrl: PropTypes.string.isRequired,
  agentName: PropTypes.string.isRequired,
  leaseVolume: PropTypes.number.isRequired,
};

SrAgentLeaderboardCell.displayName = 'SrAgentLeaderboardCell';

export default SrAgentLeaderboardCell;
